// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xkJAz","deck":"styles_deck__saxNb","section":"styles_section__B9AnF"};